import React from 'react'

export default function Ready() {
  return (
    <div className='bg-[#000000] w-full py-[20px] md:py-[50px] lg:py-[70px] text-[#FFF] text-center relative p-[20px]'>
        <h4 className='text-[24px] md:text-[32px] lg:text-[54px] font-semibold'>⚡ Only 100 Surge College Slots Available.</h4>
        {/* <p className='mt-[10px] text-[#D1D5DC] text-[12px] md:text-[16px] font-normal'>Once filled, applications reopen next year.</p> */}
        {/* <button className='mt-[14px] md:mt-[21px] w-full md:w-[365px] h-[40px] md:h-[50px] lg:h-[82px] bg-[#34C759] rounded-[14px] md:rounded-[22px] text-[16px] md:text-[25px] font-semibold mx-auto' onClick={() => { window.location.href = "/startups/form" }}>Book Your Slot</button> */}
    </div>
  )
}
